import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Clock, ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#2D3E50] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              {/* Wave icon */}
              <div className="flex flex-col items-center justify-center w-10">
                <div className="w-8 h-1 bg-white rounded-full mb-1"></div>
                <svg width="32" height="16" viewBox="0 0 32 16">
                  <path d="M0 8 Q8 0, 16 8 T32 8" stroke="#E8945A" strokeWidth="2.5" fill="none"/>
                </svg>
                <svg width="32" height="12" viewBox="0 0 32 12">
                  <path d="M0 6 Q8 0, 16 6 T32 6" stroke="white" strokeWidth="2" fill="none" opacity="0.7"/>
                </svg>
              </div>
              <div>
                <div className="flex items-baseline">
                  <span className="font-['Playfair_Display'] font-semibold text-lg text-white tracking-tight">TERRE</span>
                  <span className="font-['Playfair_Display'] font-normal text-lg text-[#E8945A] italic mx-0.5">et</span>
                  <span className="font-['Playfair_Display'] font-semibold text-lg text-white tracking-tight">MER</span>
                </div>
                <span className="text-[9px] uppercase tracking-[0.2em] text-white/60">Location de Linge</span>
              </div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-4">
              Service de location de linge de maison pour vos séjours en Bretagne. 
              Un service de location de linge par Terre et Mer Conciergerie.
            </p>
            <a 
              href="https://terreetmer-conciergerie.fr/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#E8945A] hover:text-[#f0a572] transition-colors text-sm"
            >
              Découvrir notre conciergerie
              <ExternalLink className="h-4 w-4" />
            </a>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-['Playfair_Display'] font-semibold text-lg mb-6">Nos Services</h4>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-white/70 hover:text-[#E8945A] transition-colors text-sm">
                  Particuliers & Propriétaires
                </a>
              </li>
              <li>
                <a href="#services" className="text-white/70 hover:text-[#E8945A] transition-colors text-sm">
                  Professionnels
                </a>
              </li>
              <li>
                <a 
                  href="https://terreetmer-conciergerie.fr/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-[#E8945A] transition-colors text-sm"
                >
                  Conciergerie complète
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Playfair_Display'] font-semibold text-lg mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-[#E8945A] flex-shrink-0" />
                <a href="mailto:contact@terreetmer-locationdelinge.fr" className="text-white/70 hover:text-[#E8945A] transition-colors text-sm break-all">
                  contact@terreetmer-locationdelinge.fr
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="h-5 w-5 text-[#E8945A] flex-shrink-0 mt-0.5" />
                <div className="text-white/70 text-sm space-y-1.5">
                  <div className="flex justify-between gap-6">
                    <span>Lun. — Ven.</span>
                    <span className="text-white/90">10h–12h · 14h–17h</span>
                  </div>
                  <div className="flex justify-between gap-6">
                    <span>Samedi</span>
                    <span className="text-white/90">10h–12h</span>
                  </div>
                  <div className="flex justify-between gap-6">
                    <span>Dimanche</span>
                    <span className="text-white/50">Fermé</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Terre et Mer Location de Linge. Tous droits réservés.
          </p>
          <div className="flex gap-6">
            <Link to="/mentions-legales" className="text-white/50 hover:text-[#E8945A] transition-colors text-sm" data-testid="footer-mentions-link">
              Mentions légales
            </Link>
            <Link to="/cgv" className="text-white/50 hover:text-[#E8945A] transition-colors text-sm" data-testid="footer-cgv-link">
              CGV
            </Link>
            <Link to="/mentions-legales#donnees-personnelles" className="text-white/50 hover:text-[#E8945A] transition-colors text-sm" data-testid="footer-rgpd-link">
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
